import { EMPTY_OBJECT } from '../../../../../constants/common'
import { getMockListingApplicantsCount } from '../../../../RentalPortalApplicant'
import { LISTING_PROFILE_TAB_APPLICANTS } from '../../../RentalPortal.constants'
import { getRentalPortalProfileTabCount } from '../../../RentalPortal.utils'
import { getMockListingViewingsCount } from '../../RentalPortalListingViewings.mocks'

import { LISTING_PROFILE_TAB_VIEWINGS } from './RentalPortalListingProfileTabs.constants'

// TODO: the applicants and viewings tabs read the mock, so their counters
// count the mock too until those tabs are served
function getListingProfileMockTabCounts(listingId) {
  return {
    [LISTING_PROFILE_TAB_APPLICANTS]: getMockListingApplicantsCount(listingId),
    [LISTING_PROFILE_TAB_VIEWINGS]: getMockListingViewingsCount(listingId),
  }
}

export function getListingProfileTabCounters(listingData) {
  return Object.entries({
    ...(listingData?.counts || EMPTY_OBJECT),
    ...(listingData ? getListingProfileMockTabCounts(listingData.id) : null),
  }).reduce((acc, [section, total]) => {
    acc[section] = { total: getRentalPortalProfileTabCount(total) }

    return acc
  }, {})
}
